import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import Ticker from './components/Ticker';
import Services from './components/Services';
import WhyUs from './components/WhyUs';
import Testimonials from './components/Testimonials';
import CTA from './components/CTA';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <Header />
      <Hero />
      <Services />
      <WhyUs />
      <Testimonials />
      <CTA />
      <Ticker />
      <Footer />
    </div>
  );
}

export default App;
